import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { getSelectableLowPassFilterPeriods } from '../../correlation.tools';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-default-smoothing-selector',
    templateUrl: './default-smoothing-selector.component.html',
    styleUrls: ['./default-smoothing-selector.component.scss'],
    standalone: false
})
export class DefaultSmoothingSelectorComponent {
  @Input() parentForm: UntypedFormGroup;

  public selectableLowPassFilterPeriods: any[];

  constructor(private translateService: TranslateService) {
    this.selectableLowPassFilterPeriods = getSelectableLowPassFilterPeriods(
      this.translateService
    );
  }

  get control() {
    return this.parentForm.get('defaultLowPassFilter');
  }
}
